module.exports = __webpack_public_path__ + "logoPersyval.jpg?761838dd32a8768476b60d7d6779c8de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logoPersyval.jpg
// module id = 676
// module chunks = 0